/**
 * Brasilia time utilities (UTC-3 fixed offset)
 * Used for operational period date calculations
 */

const BRASILIA_OFFSET_MINUTES = -3 * 60; // UTC-3

function getBrasiliaTime(): Date {
  const now = new Date();
  const utcMs = now.getTime() + now.getTimezoneOffset() * 60000;
  return new Date(utcMs + BRASILIA_OFFSET_MINUTES * 60000);
}

/** Returns current date in Brasilia timezone as YYYY-MM-DD */
export function getBrasiliaDate(): string {
  const brasilia = getBrasiliaTime();
  const y = brasilia.getFullYear();
  const m = String(brasilia.getMonth() + 1).padStart(2, "0");
  const d = String(brasilia.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** Returns current hour (0-23) in Brasilia timezone */
export function getBrasiliaHours(): number {
  return getBrasiliaTime().getHours();
}
